import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import ScrollToTop from "../components/common/ScrollToTop";
import OrderCheckout from "../components/shopPartials/OrderCheckout";
import { useState } from "react";
import { useGeneral } from "../components/contexts/GeneralContext";
import { useParams } from "react-router-dom";
import Checkout from "../components/planPartials/Checkout";

const CheckoutPage = () => {
  const { type } = useParams();
  const { discountCoupons } = useGeneral();
  return (
    <>
      <ScrollToTop />
      <PageWrapper className="bg-bg min-h-screen">
        <Header code={discountCoupons} />
        <BodyWrapper className="mb-4 lg:mb-0">
          {type === "order" ? <OrderCheckout /> : <Checkout />}
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default CheckoutPage;
